"use client";

import { useShallow } from "zustand/react/shallow";
import { ResponsiveModal } from "@/components/responsive-modal";
import { useI18n } from "@/locales/client";
import useFeedbackModal from "../hooks/use-feedback-modal";
import { BugReportForm } from "./bug-report-form";
import { FeedbackChooser } from "./feedback-chooser";
import { FeedbackForm } from "./feedback-form";
import { SuccessState } from "./success-state";

export const FeedbackModal = () => {
  const { isOpen, view, successType, setView, onClose, handleSuccess } =
    useFeedbackModal(
      useShallow((state) => ({
        isOpen: state.isOpen,
        view: state.view,
        successType: state.successType,
        setView: state.setView,
        onClose: state.onClose,
        handleSuccess: state.handleSuccess,
      })),
    );
  const t = useI18n();

  const getTitle = () => {
    switch (view) {
      case "chooser":
        return t("feedbackModal.title.chooser");
      case "bug":
        return t("feedbackModal.title.bug");
      case "feedback":
        return t("feedbackModal.title.feedback");
      case "success":
        return t("feedbackModal.title.success");
    }
  };

  const getDescription = () => {
    switch (view) {
      case "chooser":
        return t("feedbackModal.description.chooser");
      case "bug":
        return t("feedbackModal.description.bug");
      case "feedback":
        return t("feedbackModal.description.feedback");
      case "success":
        return undefined;
    }
  };

  const renderContent = () => {
    switch (view) {
      case "chooser":
        return (
          <FeedbackChooser
            onSelectBug={() => setView("bug")}
            onSelectFeedback={() => setView("feedback")}
          />
        );
      case "bug":
        return (
          <BugReportForm
            onBack={() => setView("chooser")}
            onSuccess={() => handleSuccess("bug")}
          />
        );
      case "feedback":
        return (
          <FeedbackForm
            onBack={() => setView("chooser")}
            onSuccess={() => handleSuccess("feedback")}
          />
        );
      case "success":
        return <SuccessState type={successType} onClose={onClose} />;
    }
  };

  return (
    <ResponsiveModal
      className="max-w-[440px]"
      title={getTitle()}
      description={getDescription()}
      form={renderContent()}
      open={isOpen}
      onOpenChange={onClose}
    />
  );
};
